module.exports = __webpack_public_path__ + "static/ifa-fd6b067fbf444e828041f33185d4b6b2.jpg";